import { render, staticRenderFns } from "./WxH5Pay.vue?vue&type=template&id=03590da4&scoped=true&"
import script from "./WxH5Pay.vue?vue&type=script&lang=js&"
export * from "./WxH5Pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03590da4",
  null
  
)

export default component.exports